import { Eye, EyeClosed } from 'lucide-react';
import { useState, type InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import EvaInput from '../EvaInput';

import styles from './index.module.scss';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  readonly isDanger?: boolean;
};

/** 带显隐切换的密码输入框(EVA 风格,内部基于 EvaInput)。 */
const EvaPasswordInput = ({ isDanger, ...props }: Props) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <EvaInput
      type={visible ? 'text' : 'password'}
      isDanger={isDanger}
      suffix={
        <button
          type="button"
          className={styles.toggle}
          aria-label={visible ? t('eva_domestic.hide_password') : t('eva_domestic.show_password')}
          aria-pressed={visible}
          onClick={() => {
            setVisible((value) => !value);
          }}
        >
          {visible ? (
            <Eye aria-hidden size={20} strokeWidth={1.4} />
          ) : (
            <EyeClosed aria-hidden size={20} strokeWidth={1.4} />
          )}
        </button>
      }
      {...props}
    />
  );
};

export default EvaPasswordInput;
